import { isEqual } from 'lodash';
import { FC, Fragment, useEffect, useState } from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import CustomSelect from '../../../components/forms/CustomSelect';
import CustomTextDelayInput from '../../../components/forms/CustomTextDelayInput';
import DateField from '../../../components/forms/DateField';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import useDepartments from '../../../hooks/api-calls/useDepartments';
import useUserNetworks from '../../../hooks/api-calls/useUserNetworks';
import useUsers from '../../../hooks/api-calls/useUsers';
import { FilterOptions } from '../../../hooks/useFilters';
import { LeadsService } from '../../../services/leads/leadsService';

interface ICallFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
}

const CallFilters: FC<ICallFiltersProps> = ({ filters, updateFilters, resetFilters }) => {

    // HOOKS
    const { userCan } = usePrivilege();
    const { getDepartmentsList } = useDepartments();
    const { getUsersList } = useUsers();
    const { getUserNetworksList } = useUserNetworks();

    // RENDER

    return (
        <Fragment>
            <CustomTextDelayInput
                id="search_text"
                label="Buscar"
                filters={filters}
                updateFilters={updateFilters}
            />

            {userCan('list_user', 'user') && userCan('get_users_for_select', 'user') && (
                <CustomSelect
                    id="user"
                    label="Usuario Realizador"
                    isMulti={true}
                    options={getUsersList()}
                    value={filters.filter_filters?.user ?
                        getUsersList().filter((type) => filters.filter_filters?.user?.includes(type.value)) : []}
                    onChange={(value: { value: string, label: string }[]) => {
                        const users = value.map((type) => type.value);
                        if (users !== filters.filter_filters?.user) {
                            updateFilters({ user: users });
                        }
                    }}
                />
            )}

            <CustomSelect
                id="commercial_networks"
                label="Redes Comerciales"
                isMulti={true}
                options={getUserNetworksList()}
                value={filters.filter_filters?.commercial_networks ?
                    getUserNetworksList().filter((type) => filters.filter_filters?.commercial_networks?.includes(type.value)) : []}
                onChange={(value: { value: string, label: string }[]) => {
                    const networks = value.map((type) => type.value);
                    if (networks !== filters.filter_filters?.commercial_networks) {
                        updateFilters({ commercial_networks: networks });
                    }
                }}
                display={userCan('list_commercial_network', 'commercial_network')}
            />

            <CustomSelect
                id="departments"
                label="Departamentos"
                isMulti={true}
                options={getDepartmentsList()}
                value={filters.filter_filters?.departments ?
                    getDepartmentsList().filter((type) => filters.filter_filters?.departments?.includes(type.value)) : []}
                onChange={(value: { value: string, label: string }[]) => {
                    const departments = value.map((type) => type.value);
                    if (departments !== filters.filter_filters?.departments) {
                        updateFilters({ departments: departments });
                    }
                }}
                display={userCan('list_departments', 'departments')}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Llamada"
                placeholderText="Selecciona las fechas"
                selectedDateField={"call_date"}
                startDate={filters.filter_filters?.call_date?.startDate ? new Date(filters.filter_filters.call_date.startDate) : null}
                endDate={filters.filter_filters?.call_date?.endDate ? new Date(filters.filter_filters.call_date.endDate) : null}
                onChange={(date: any) => {
                    const filters_call_date = filters.filter_filters?.call_date;
                    const call_date = date ? { startDate: date[0], endDate: date[1] } : null;
                    if (call_date && !isEqual(filters_call_date, call_date)) {
                        updateFilters({ call_date: { startDate: date[0], endDate: date[1] } });
                    } else if (!call_date && filters_call_date) {
                        updateFilters({ call_date: null });
                    }
                }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                selectedDateField={"created_date"}
                startDate={filters.filter_filters?.created_date?.startDate ? new Date(filters.filter_filters.created_date.startDate) : null}
                endDate={filters.filter_filters?.created_date?.endDate ? new Date(filters.filter_filters.created_date.endDate) : null}
                onChange={(date: any) => {
                    const filters_created_date = filters.filter_filters?.created_date;
                    const created_date = date ? { startDate: date[0], endDate: date[1] } : null;
                    if (created_date && !isEqual(filters_created_date, created_date)) {
                        updateFilters({ created_date: { startDate: date[0], endDate: date[1] } });
                    } else if (!created_date && filters_created_date) {
                        updateFilters({ created_date: null });
                    }
                }}
            />

            <Button
                size="sm"
                onClick={() => {
                    resetFilters(50);
                }}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>
        </Fragment>
    )
}

export default CallFilters;